import { render } from "./PropertyControlLabel.vue?vue&type=template&id=fa4f1a6c&scoped=true"
import script from "./PropertyControlLabel.vue?vue&type=script&lang=js"
export * from "./PropertyControlLabel.vue?vue&type=script&lang=js"

import "./PropertyControlLabel.vue?vue&type=style&index=0&id=fa4f1a6c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa4f1a6c"]])

export default __exports__